/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Theme } from "@mui/material/styles";

export default function Skeleton(theme: Theme): any {
  return {
    MuiSkeleton: {
      defaultProps: { animation: "wave" },

      styleOverrides: {
        root: {
          backgroundColor: theme.palette.background.neutral,

          transform: "scale(1, 1)",
        },
      },
    },
  };
}
